// import {Vue} from 'vue-demi'
import { createStore } from 'vuex'
import auth from './modules/auth/'
import binaries from './modules/binaries/'
import categories from './modules/categories/'
import contract from './modules/contract/'
import promotions from './modules/promotions/'
import designers from './modules/designers/'
import errors from './modules/errors/'
import foundrySettings from './modules/foundry-settings/'
import foundrySupport from './modules/foundry-support/'
import graphics from './modules/graphics/'
import overlay from './modules/overlay/'
import packages from './modules/packages/'
import profile from './modules/profile/'
import settings from './modules/settings/'
import submissions from './modules/submissions/'
import payments from './modules/payments/'
import salesReport from './modules/sales-report/'
import accounts from './modules/accounts/'
import signUp from './modules/sign-up/'
import tags from './modules/tags/'
import families from './modules/families/'
import downloadBinaryImages from './modules/download-binary-images/'
import bulkImport from './modules/bulk-import'
import sideNavigation from './modules/side-navigation'
import dashboard from './modules/dashboard'
import impersonate from './modules/impersonate'
import bundle from './modules/bundle-submission/'
import bannedword from './modules/bannedword/'
import metrics from './modules/metrics/'
import healthReport from './modules/foundry-health'
import inventoryingestion from './modules/inventoryingestion'
import mfpNumbers from './modules/mfp-numbers'
import dropship from './modules/dropship/'

// Vue.use(Vuex)

const store = createStore({
  modules: {
    auth,
    binaries,
    categories,
    contract,
    designers,
    errors,
    foundrySettings,
    foundrySupport,
    graphics,
    packages,
    overlay,
    payments,
    salesReport,
    accounts,
    profile,
    promotions,
    settings,
    submissions,
    tags,
    families,
    downloadBinaryImages,
    signUp,
    bulkImport,
    sideNavigation,
    dashboard,
    impersonate,
    bundle,
    bannedword,
    healthReport,
    inventoryingestion,
    metrics,
    mfpNumbers,
    dropship,
  }
})

export default store
